<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_7620_33666)">
      <path d="M3 6.99999C2.33333 6.66665 1 5.49999 1 3.49999C1 0.999987 3.25183 0.168538 4.5 1.00045C6 2.00021 7.5 2.49999 7.5 8.99999C7.5 13.5 4 15 3 15C2 15 0.805089 12.5 4 8.99999C7.19491 5.49999 9 5.49999 10 5.99999C10.8 6.39999 11.5 7.99999 11 10.5C11.4 8.49999 13.1 6.39999 15.5 7.99999M9 14H14.5" stroke="#232323" stroke-width="1.5" stroke-linecap="round"/>
    </g>
    <defs>
      <clipPath id="clip0_7620_33666">
        <rect width="16" height="16" fill="white" transform="matrix(-1 0 0 1 16 0)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  name: 'IconConsent'
}
</script>
